import React, { FC, memo } from 'react';
import { useFormikContext } from 'formik';
import DropdownWithChildren from '@minecraft.dropdown-with-children';
import { FilterData } from '../../../shared/types';
import { DateRange } from '../../../FilterCollection';

type Props = {
  isClearable?: boolean;
  withDelimiter?: boolean;
  dateFormat?: 'standard' | 'short';
  dateRangeName: FilterData['name'];
  dateRangeMinName: FilterData['name'];
  dateRangeMaxName: FilterData['name'];
  label: FilterData['label'];
};

const DropdownDateRange: FC<Props> = ({
  isClearable,
  withDelimiter,
  dateFormat,
  dateRangeName,
  dateRangeMinName,
  dateRangeMaxName,
  label,
}) => {
  const { values } = useFormikContext();
  const dateRangeMinValue = values[dateRangeName][dateRangeMinName];
  const dateRangeMaxValue = values[dateRangeName][dateRangeMaxName];

  return (
    <DropdownWithChildren isChildrensContentFilled={dateRangeMinValue || dateRangeMaxValue} toggleLabel={label}>
      <DateRange
        isClearable={isClearable}
        withDelimiter={withDelimiter}
        dateFormat={dateFormat}
        dateRangeName={dateRangeName}
        dateRangeMinName={dateRangeMinName}
        dateRangeMaxName={dateRangeMaxName}
      />
    </DropdownWithChildren>
  );
};

export default memo(DropdownDateRange);
